/**
 * Viral video showcase: Swiper carousel, muted autoplay on active slide, 5s auto-advance.
 */
(function () {
  var AUTOPLAY_MS = 5000;

  function pauseAllVideos(root) {
    root.querySelectorAll('.viral-video-showcase__video').forEach(function (video) {
      video.pause();
    });
  }

  function clearAutoplay(swiper) {
    if (swiper && swiper._viralAutoplayTimer) {
      clearTimeout(swiper._viralAutoplayTimer);
      swiper._viralAutoplayTimer = null;
    }
  }

  function scheduleAutoplay(swiper) {
    clearAutoplay(swiper);
    swiper._viralAutoplayTimer = setTimeout(function () {
      swiper._viralAutoplayTimer = null;
      swiper.slideNext();
    }, AUTOPLAY_MS);
  }

  function playActiveVideo(root, swiper) {
    pauseAllVideos(root);
    var activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;
    var video = activeSlide.querySelector('.viral-video-showcase__video');
    if (!video) return;
    video.muted = true;
    try {
      video.currentTime = 0;
    } catch (e) {}
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {});
    }
  }

  function initShowcase(root) {
    if (typeof Swiper === 'undefined') return;

    var swiperEl = root.querySelector('.viral-video-showcase__swiper');
    var prevBtn = root.querySelector('.viral-video-showcase__nav--prev');
    var nextBtn = root.querySelector('.viral-video-showcase__nav--next');
    var slideCount = parseInt(root.getAttribute('data-slide-count'), 10) || 0;

    if (!swiperEl || slideCount < 1) return;

    var MIN_SLIDES = 6;
    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    var originalSlides = Array.prototype.slice.call(wrapper.querySelectorAll('.swiper-slide'));
    if (originalSlides.length > 0 && originalSlides.length < MIN_SLIDES) {
      var times = Math.ceil(MIN_SLIDES / originalSlides.length);
      for (var t = 1; t < times; t++) {
        originalSlides.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          wrapper.appendChild(clone);
        });
      }
    }

    var isMobile = window.innerWidth <= 1024;

    var swiperInstance = null;

    var config = {
      loop: true,
      slidesPerView: 'auto',
      initialSlide: 0,
      centeredSlides: true,
      centerInsufficientSlides: true,
      spaceBetween: 24,
      speed: 450,
      grabCursor: isMobile,
      simulateTouch: isMobile,
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        1025: {
          slidesPerView: 'auto',
          spaceBetween: 40,
          centeredSlides: true,
          centerInsufficientSlides: true,
          watchOverflow: true,
        },
      },
    };

    config.on = {
      afterInit: function (swiper) {
        playActiveVideo(root, swiper);
        scheduleAutoplay(swiper);
      },
      slideChangeTransitionStart: function () {
        pauseAllVideos(root);
      },
      slideChangeTransitionEnd: function (swiper) {
        playActiveVideo(root, swiper);
        scheduleAutoplay(swiper);
      },
      resize: function (swiper) {
        var mobile = window.innerWidth <= 1024;
        swiper.params.simulateTouch = mobile;
        swiper.params.grabCursor = mobile;
        swiper.update();
        clearAutoplay(swiper);
        scheduleAutoplay(swiper);
      },
      beforeDestroy: function () {
        clearAutoplay(swiperInstance);
        pauseAllVideos(root);
      },
    };

    swiperInstance = new Swiper(swiperEl, config);
  }

  function initAll() {
    document.querySelectorAll('[data-viral-video-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
